export default "__VITE_ASSET__j22OmlXG__"